import { useCallback } from "react";
import ShareIcon from "@/common/components/icons/share";
import classNames from "@/common/utils/classNames";
import { getProfileShareUrl } from "../utils/profileUrl";
import { shareAppUrl } from "../utils/shareAppUrl";
import { GLASS_ROUND, ProfileHeroAction, ProfileHeroGlassButton } from "./ProfileHeroShell";

export default function ProfileShareButton({
  remoteId,
  displayName,
  variant = "toolbar",
  className = "",
}) {
  const handleShare = useCallback(async () => {
    const shareUrl = getProfileShareUrl(remoteId);
    if (!shareUrl) return;
    const name = (displayName || "کاربر").trim();
    await shareAppUrl({
      url: shareUrl,
      title: `پروفایل ${name}`,
      text: `پروفایل ${name}`,
      copySuccessMessage: "لینک پروفایل در کلیپ‌بورد کپی شد.",
    });
  }, [remoteId, displayName]);

  if (remoteId == null) return null;

  if (variant === "action") {
    return (
      <ProfileHeroAction
        onClick={handleShare}
        title="اشتراک‌گذاری پروفایل"
        aria-label="اشتراک‌گذاری پروفایل"
        label="اشتراک"
        icon={<ShareIcon className="h-5 w-5" aria-hidden />}
      />
    );
  }

  return (
    <ProfileHeroGlassButton
      className={classNames(GLASS_ROUND, className)}
      onClick={handleShare}
      aria-label="اشتراک‌گذاری پروفایل"
      title="اشتراک‌گذاری پروفایل"
    >
      <ShareIcon className="h-6 w-6" aria-hidden />
    </ProfileHeroGlassButton>
  );
}
